// extracted by mini-css-extract-plugin
export default {"inputBox":"input_inputBox__oWZbf"};